import React, { useState, useRef, useLayoutEffect } from "react";
interface IProps {
  children?: React.ReactNode;
  active: boolean;
  fixed?: boolean;
}

const Collapse = ({ fixed = true, children, active = false }: IProps) => {
  const [height, setHeightState] = useState("0px");
  const content = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!active) {
      setHeightState("0px");
    } else if (fixed) {
      setHeightState("100px");
    } else {
      setHeightState("auto");
    }
  }, [active, children, fixed]);

  return (
    <div
      ref={content}
      className="w-full overflow-y-auto"
      style={{ maxHeight: height, transition: "max-height 0.3s ease" }}
    >
      {children}
    </div>
  );
};

export default Collapse;
